var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orgId)?_c('div',{staticClass:"container orgs"},[_c('b-dropdown',{attrs:{"right":"","split":"","split-variant":"outline-primary","variant":"primary","text":_vm.orgName}},[_c('organization-dropdown-tree',{attrs:{"orgs":_vm.orgs},on:{"changeOrg":_vm.changeOrg}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }